<template>
  <a @click.prevent="emitClick" class="action-link" :class="setClassModifiers('action-link--')">
    <div v-if="iconLeft" :class="iconLeft" class="action-link__icon action-link__icon--left"></div>
    <div>
      <slot></slot>
    </div>
    <div v-if="iconRight" :class="iconRight" class="action-link__icon action-link__icon--right"></div>
  </a>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  props: {
    iconLeft: {
      type: String,
      default: null
    },

    iconRight: {
      type: String,
      default: null
    },

    size: {
      type: String,
      default: null
    },

    /**
     * @values success, error, space, secondary, primary
     */
    color: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    emitClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  },

  mixins: [setClassModifiers]
}
</script>

<style lang="scss">
  @mixin color($name) {
    color: $name;
    &:link, &:visited {
      color: darken($name, 20%);
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: lighten($name, 10%);
      }
    }
  }

  .action-link {
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-transform: uppercase;
    line-height: .9;
    cursor: pointer;
    transition: all .2s;
    white-space: nowrap;

    @include color($color-primary);

    &--error {
      @include color($color-error);
    }

    &--success {
      @include color($color-success);
    }

    &--space {
      @include color($color-space);
    }

    &--primary {
      @include color($color-primary);
    }

    &--secondary {
      @include color($color-secondary);
    }

    &__icon {
      /*color: $color-space;*/
      font-size: 2.4rem;

      &--right {
        margin-left: .5rem;
      }

      &--left {
        margin-right: .5rem;
      }
    }

    &--small {
      font-size: 1.2rem;
      .action-link__icon {
        font-size: 1.4rem;
      }
    }

    &--x-small {
      font-size: 1.1rem;
      .action-link__icon {
        font-size: 1.2rem;
      }
    }

    &--disabled {
      @include color($color-space)
    }
  }
</style>
